import React, {useEffect} from 'react'
import {useOnEvent} from 'react-app-events'
import {AddressForm} from '@components/Address'
import Loading from '@components/Loading'
import {getMyOrderPreferences_preferences} from '@data/queries/preferences/__generated__/getMyOrderPreferences'
import {getWebsiteMenuInformation_cached_website} from '@data/queries/website/__generated__/getWebsiteMenuInformation_cached'
import {AddressFormType} from '@helpers/addresses/models'
import scrollTo from '@helpers/misc/scrollTo'
import sleep from '@helpers/misc/sleep'
import useRef from '@hooks/useRef'
import useShouldUseNewAddressesUI from '@hooks/useShouldUseNewAddressesUI'
import useState from '@hooks/useState'

import MobileSkeleton from './MobileSkeleton'
import OptionsTableServe from './OptionsTableServe'
import UpdateBasicOptions from './UpdateBasicOptions'

import styles from './styles.module.css'

export default function Options(props: {
  preferences: getMyOrderPreferences_preferences
  website: getWebsiteMenuInformation_cached_website
  layout: string
}) {
  const container = useRef()
  const [className, setClassName] = useState('')
  const [hiddenPrice, setHiddenPrice] = useState(false)
  const {preferences, website, layout} = props
  const shouldUseNewAddressesUI = useShouldUseNewAddressesUI()

  useOnEvent('hiddenPriceProductOpened', async () => {
    setClassName(styles.shake)
    scrollTo({top: 0})
    setHiddenPrice(true)
    await sleep(1500)
    setClassName('')
  })

  useEffect(() => {
    setHiddenPrice(false)
  }, [preferences])

  if (!preferences.cart) {
    if (layout === 'mobile') {
      return <MobileSkeleton />
    }

    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    )
  }

  const hide = preferences.deliveryType === 'serve' && preferences.tableName !== null

  if (hide) {
    return <OptionsTableServe {...props} />
  }

  return (
    <div
      className={`${styles.container} ${className} ${hiddenPrice ? styles.hiddenPrice : ''}`}
      ref={container}>
      {hiddenPrice ? <p>Necesitamos tu dirección para poder continuar con el pedido</p> : null}
      {shouldUseNewAddressesUI ? (
        <AddressForm
          type={AddressFormType.Form}
          websiteId={preferences.websiteId}
          closeModal={() => {}}
        />
      ) : (
        <UpdateBasicOptions
          showStoreName={website.showStoreName || null}
          layout={layout}
          {...props}
        />
      )}
    </div>
  )
}
